import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import ProgressBar from '../ProgressBar';
import {useTranslation} from 'react-i18next';

export default function EndScreen({onClick, showProgress, onComplete}) {
    const {t} = useTranslation();
    const [percent, setPercent] = useState(0);
    const [time, setTime] = useState(5);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setPercent(1);
        }, 100);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTime(Math.max(time - 1, 0));
        }, 1000);
        if (time === 0) {
            onComplete();
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [time]);

    return (
        <Container>
            <Content onClick={onClick}>
                <RetryImage />
                <Title>{t('playerui.replay.title')}</Title>
                {showProgress && (
                    <>
                        <NextText>
                            {t('playerui.replay.nextTimer')} {time}
                        </NextText>
                        <ProgressBar
                            percent={percent}
                            transition="5s linear"
                            height={8}
                            cornerRadius={4}
                            trackColor="#8a8884"
                        />
                    </>
                )}
            </Content>
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 260px;
    align-items: center;
    cursor: pointer;
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd, Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    margin-bottom: 48px;
`;

const NextText = styled.div`
    font-family: AvenirNextRoundedStd, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: white;
    margin-bottom: 12px;
`;

const RetryImage = styled.img.attrs({
    src: require('../../assets/playerui/ic_restart.png'),
})`
    width: 50px !important;
    height: 50px !important;
    margin-bottom: 20px;
`;
